import React, { Context, createContext, useReducer, useEffect } from 'react';
import { Registration } from '@stax-core/types-omni';
import {
  RegistrationAction,
  RegistrationContext,
  RegistrationContextProps,
  RegistrationState,
} from './Registration.types';

const RegistrationStore = createContext(
  {} as RegistrationContext,
) as Context<RegistrationContext>;

const initialState: RegistrationState = {
  registration: null,
  effect: null,
};

type Reducer = (
  state: RegistrationState,
  action: RegistrationAction,
) => RegistrationState;

const storeReducer: Reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_REGISTRATION':
      const registration = { ...action.payload } as Registration;
      const isMetaEmpty =
        registration.meta == null ||
        Array.isArray(registration.meta);
      registration.meta = isMetaEmpty ? {} : registration.meta;

      return {
        ...state,
        registration: registration,
        effect: {
          type: 'UPDATE_REGISTRATION',
          payload: { registration: state.registration! },
        },
      };
    case 'REMOVE_REGISTRATION':
      return { ...state, registration: null };
    default:
      return state;
  }
};

const RegistrationProvider = (props: RegistrationContextProps) => {
  const [state, dispatch] = useReducer(
    storeReducer,
    props.initialState ?? initialState,
  );

  const { effect } = state;

  useEffect(() => {
    switch (effect?.type) {
      case 'UPDATE_REGISTRATION':
        localStorage.setItem(
          'selfreg.registration',
          JSON.stringify(effect.payload),
        );
        break;
      case 'REMOVE_REGISTRATION':
        localStorage.removeItem('selfreg.registration');
        break;
      default:
        break;
    }
  }, [effect]);

  const localContext: RegistrationContext = {
    state: state,
    dispatch: dispatch,
  };

  return (
    <RegistrationStore.Provider value={localContext}>
      {props.children}
    </RegistrationStore.Provider>
  );
};

export { RegistrationStore, RegistrationProvider };
